
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">Court Documents</h3>
      <p>Please use the links below to view a full copy of the various Notices.</p>
      <ul>
        <li>
          <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf"
             target="_blank">
            Notice of Proposed Class Action Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL_ES(US).pdf"
             target="_blank">
            Aviso de Propuesta de Acuerdo de Demanda Colectiva - Español
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/Burke v. Visa-Summary Notice_FINAL.pdf"
             target="_blank">
            Summary Notice of Proposed Class Action Settlement
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/Burke v Visa_Summary Notice_ES(US).pdf"
             target="_blank">
            Resumen del Aviso de Propuesta de Acuerdo de Demanda Colectiva – Español
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
